var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intellectual"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"page-title"},[_vm._v("知识产权保护")]),_c('p',[_vm._v("如果您发现第三方存在侵犯魔力玛特依法享有的知识产权的情况（例如：生产、销售盗版或山寨、未经授权使用IP形象进行推广宣传等），请您通过以下方式与我们联系，告知相关的信息。")]),_c('p',{staticClass:"tip"},[_vm._v("如涉及中国大陆地区的侵权举报或授权验证，请联系邮箱：hanfeifei@baikewan.com")])])])])
}]

export { render, staticRenderFns }